import './styles.css';
import {  useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { ImpactTab } from "../../../Components/Plea/PleaSocioEnvironmentalTabs/impactTab";
import { SocioEnvironmentalTab } from "../../../Components/Plea/PleaSocioEnvironmentalTabs/socioEnvironmentalTab";
import { PremisesTab } from "../../../Components/Plea/PleaSocioEnvironmentalTabs/premisesTab";
import { Tabs, TabsProps } from "antd";


export default function SocioEnvironmentalPlea() {

    const { company } = useContext(CompanyContext);
    const { pleaId } = useParams();
    const [active, setActive] = useState('1');

    const onChange = (newActive: string) => {
        setActive(newActive)
    }
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: "Premissas",
            children:<PremisesTab pleaId={pleaId ? pleaId : ""} company={company} />
        },
        {
            key: '2',
            label: "Impactos e Ações Mitigadoras",
            children: <ImpactTab pleaId={pleaId ? pleaId : ""} companyId={company.id} />
        },        
        {
            key: '3',
            label: "Quadro Socioambiental",
            children:<SocioEnvironmentalTab pleaId={pleaId ? pleaId : ""} companyId={company.id} />
        },
    ];

    return (
        <div className='page-block'>
            <Tabs className='tab-menu' onChange={onChange} activeKey={active} items={items}/>
        </div>
    );
}